"use client";

import { Tabs, TabsList, TabsTrigger } from "@/components/shadcn/tabs";
import { NewsCategories } from "@prisma/client";
import { useTranslations } from "next-intl";
import { useRouter, useSearchParams } from "next/navigation";

type NewsArticlesFilterProps = {
    newsCategories: NewsCategories[] | null | undefined;
};

export default function NewsArticlesFilter({
    newsCategories,
}: NewsArticlesFilterProps) {
    const t = useTranslations("news");
    const router = useRouter();
    const searchParams = useSearchParams();
    const currentCategoryId = searchParams.get("CategoryId") || "0";

    const handleOnChange = (value: string) => {
        const newSearchParams = new URLSearchParams(searchParams);
        if (value === "0") {
            newSearchParams.delete("CategoryId");
        } else {
            newSearchParams.set("CategoryId", value);
        }
        newSearchParams.delete("page");
        router.push(`/haberler/tum-haberler?${newSearchParams.toString()}`);
    };

    return (
        <Tabs value={currentCategoryId} onValueChange={handleOnChange}>
            <TabsList variant="line">
                <TabsTrigger value="0">{t("allNews")}</TabsTrigger>
                {newsCategories?.map((item) => (
                    <TabsTrigger
                        key={`NewsArticlesFilters-${item.Id}`}
                        value={item.Id.toString()}
                    >
                        {item.Name}
                    </TabsTrigger>
                ))}
            </TabsList>
        </Tabs>
    );
}
